import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  Long: { input: any; output: any; }
  ParameterInput: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ActionResult = {
  __typename?: 'ActionResult';
  success: Scalars['Boolean']['output'];
};

export type AsyncActionDto = {
  __typename?: 'AsyncActionDto';
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  status: Status;
  type: Type;
};

export type AsyncIssueCredentialsForIndicatorsInput = {
  credentialInput: CredentialInput;
  gitRemoteInput: GitRemoteInput;
  subjectIds: Array<Scalars['Long']['input']>;
};

export type AuditInfoDto = {
  __typename?: 'AuditInfoDto';
  createdAt: Scalars['LocalDateTime']['output'];
  createdBy: SimpleUserDto;
};

export type BaseParameter = {
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreateRoleInput = {
  name: Scalars['String']['input'];
  permissions: Array<Scalars['UUID']['input']>;
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roleId: Scalars['UUID']['input'];
  temporaryPassword: Scalars['String']['input'];
};

export type CredentialInput = {
  indicators: Array<IndicatorInput>;
  issueAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
  revokeAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type CredentialMutationFailureDto = {
  __typename?: 'CredentialMutationFailureDto';
  location: FailureLocation;
  reasonPhrase: Scalars['String']['output'];
};

export type CredentialRevocationResultDto = {
  __typename?: 'CredentialRevocationResultDto';
  id: Scalars['UUID']['output'];
  scheduled: Scalars['Boolean']['output'];
  successful: Scalars['Boolean']['output'];
  unsuccessful?: Maybe<CredentialMutationFailureDto>;
};

export type DateParameterDto = {
  maxInclusive?: Maybe<Scalars['String']['output']>;
  minInclusive?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DateRangeParameterDto = BaseParameter & ParameterDto & {
  __typename?: 'DateRangeParameterDto';
  endMaxDate?: Maybe<Scalars['String']['output']>;
  endMinDate?: Maybe<Scalars['String']['output']>;
  maxDatePath: Scalars['String']['output'];
  minDatePath: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  startMaxDate?: Maybe<Scalars['String']['output']>;
  startMinDate?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DateRangeParameterInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDatePath: Scalars['String']['input'];
  path: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startDatePath: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type EndDateParameterDto = BaseParameter & DateParameterDto & ParameterDto & {
  __typename?: 'EndDateParameterDto';
  maxInclusive?: Maybe<Scalars['String']['output']>;
  minInclusive?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type EndDateParameterInput = {
  path: Scalars['String']['input'];
  possibleValues: Array<Scalars['Date']['input']>;
  type: Scalars['String']['input'];
};

export type ExchangeProfileDto = {
  __typename?: 'ExchangeProfileDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tagsAndBranches: Array<TagOrBranch>;
  url: Scalars['String']['output'];
};

export type ExchangeProfileWithCredentials = {
  __typename?: 'ExchangeProfileWithCredentials';
  credentials: Array<VerifiableQueryCredentialDto>;
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type Failure = {
  __typename?: 'Failure';
  /** Input for the indicator that cannot be issued for the given subject ID. */
  indicator: IndicatorDto;
  /** Reason why the credential cannot be issued for the given subject ID at this time. */
  reason: FailureReason;
  /** ID of the subject-DID for which the credential cannot be issued. */
  subjectId: Scalars['Long']['output'];
};

export enum FailureLocation {
  Clientside = 'CLIENTSIDE',
  Serverside = 'SERVERSIDE'
}

export enum FailureReason {
  /** The credential for the given subject ID and the version already exists, and cannot be issued again. */
  ConflictingCredential = 'CONFLICTING_CREDENTIAL',
  /** The subject DID does not have a healthcare office IRI configured, but the credential requires one to fill a parameter. */
  MissingHealthcareOfficeIri = 'MISSING_HEALTHCARE_OFFICE_IRI'
}

export type FilterIssuedHealthcareProviderExcerptCredentialInput = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type GitRemoteInput = {
  branchOrTag?: InputMaybe<Scalars['String']['input']>;
  repositoryUrl: Scalars['String']['input'];
};

export type HealthcareProviderDetailsDto = {
  __typename?: 'HealthcareProviderDetailsDto';
  cocNumber: Scalars['String']['output'];
  did: Scalars['String']['output'];
  hasIssuedCredential: Scalars['Boolean']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type HealthcareProviderDto = {
  __typename?: 'HealthcareProviderDto';
  cocNumber: Scalars['String']['output'];
  did: Scalars['String']['output'];
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type HealthcareProviderExcerptCredentialIssuanceResultDto = {
  __typename?: 'HealthcareProviderExcerptCredentialIssuanceResultDto';
  id: Scalars['Long']['output'];
  successful: Scalars['Boolean']['output'];
  unsuccessful?: Maybe<CredentialMutationFailureDto>;
};

export type HealthcareProviderExcerptExistenceDto = {
  __typename?: 'HealthcareProviderExcerptExistenceDto';
  cocNumber: Scalars['String']['output'];
  exists: Scalars['Boolean']['output'];
};

export type IndicatorDetailDto = {
  __typename?: 'IndicatorDetailDto';
  indicator: IndicatorDto;
  ontologies: Array<OntologyDto>;
  parameters: Array<ParameterDto>;
  paramsSHACL?: Maybe<Scalars['String']['output']>;
  profileUrl: Scalars['String']['output'];
  queryDescription: Scalars['String']['output'];
  queryName: Scalars['String']['output'];
  sparql: Scalars['String']['output'];
};

export type IndicatorDto = {
  __typename?: 'IndicatorDto';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type IndicatorInput = {
  name: Scalars['String']['input'];
  parameters?: InputMaybe<Array<Scalars['ParameterInput']['input']>>;
  path: Scalars['String']['input'];
};

export type IssuedCredentialDetailsDto = {
  __typename?: 'IssuedCredentialDetailsDto';
  exchangeProfile?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  issuedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  nutsId?: Maybe<Scalars['String']['output']>;
  shacl?: Maybe<Scalars['String']['output']>;
  sparql?: Maybe<Scalars['String']['output']>;
  tagOrBranch?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserDto>;
};

export enum IssuedCredentialStatusEnum {
  Issued = 'ISSUED',
  NotIssued = 'NOT_ISSUED',
  Revoked = 'REVOKED',
  ScheduledForIssuance = 'SCHEDULED_FOR_ISSUANCE',
  ScheduledForRevocation = 'SCHEDULED_FOR_REVOCATION'
}

export type IssuedHealthcareProviderExcerptCredentialDto = {
  __typename?: 'IssuedHealthcareProviderExcerptCredentialDto';
  healthcareProvider: HealthcareProviderDto;
  id: Scalars['UUID']['output'];
  revokedBy?: Maybe<Scalars['String']['output']>;
};

export type IssuedHealthcareProviderExcerptCredentialPage = {
  __typename?: 'IssuedHealthcareProviderExcerptCredentialPage';
  page: Scalars['Int']['output'];
  rowCount: Scalars['Int']['output'];
  rows: Array<IssuedHealthcareProviderExcerptCredentialDto>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new role */
  createRole: RoleDto;
  /** Create a new user */
  createUser: UserDto;
  /** Deactivate a user */
  deactivateUser: UserDto;
  /** Deletes a role by its ID */
  deleteRole: Scalars['Boolean']['output'];
  /** Delete a user */
  deleteUser: Scalars['Boolean']['output'];
  /** Issue a Healthcare provider excerpt-credential for each of the given IDs */
  issueCredentialsForHealthcareProviders: Array<HealthcareProviderExcerptCredentialIssuanceResultDto>;
  /**
   * For each of the given indicators within the given repo, issue a Verifiable Query Credential for the given subjectId and return whether that was successful
   * @deprecated use StartIssueCredentialsForIndicatorsTaskMutation instead, this mutation may time out for large requests
   */
  issueCredentialsForIndicators: Array<VerifiableQueryCredentialIssuanceResultDto>;
  /** Reactivate a user */
  reactivateUser: UserDto;
  /** Revoke one or more Healthcare Provider Excerpt credentials */
  revokeHealthcareProviderExcerptCredential: Array<CredentialRevocationResultDto>;
  /** Revoke a subject with a given ID */
  revokeSubjectDid: ActionResult;
  /** Revoke one or more Verifiable Query credentials (at the given time, or immediately if omitted) */
  revokeVerifiableQueryCredentials: Array<CredentialRevocationResultDto>;
  /** Start an async action to issue verifiable query credentials for indicators. Use `checkAsyncAction` to check the status. */
  startIssueCredentialsForIndicatorsAction: AsyncActionDto;
  /** Update a role */
  updateRole: RoleDto;
  updateSubjectDid: SubjectDidDto;
  /** Update a user */
  updateUser: UserDto;
};


export type MutationCreateRoleArgs = {
  input: CreateRoleInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeactivateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteRoleArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationIssueCredentialsForHealthcareProvidersArgs = {
  ids: Array<Scalars['Long']['input']>;
};


export type MutationIssueCredentialsForIndicatorsArgs = {
  credentialInput: CredentialInput;
  input: GitRemoteInput;
  subjectIds: Array<Scalars['Long']['input']>;
};


export type MutationReactivateUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRevokeHealthcareProviderExcerptCredentialArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationRevokeSubjectDidArgs = {
  id: Scalars['Long']['input'];
};


export type MutationRevokeVerifiableQueryCredentialsArgs = {
  ids: Array<Scalars['UUID']['input']>;
  revokeAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
};


export type MutationStartIssueCredentialsForIndicatorsActionArgs = {
  input: AsyncIssueCredentialsForIndicatorsInput;
};


export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};


export type MutationUpdateSubjectDidArgs = {
  input: UpdateSubjectDidInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type OntologyDto = {
  __typename?: 'OntologyDto';
  tagOrBranch: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum Operator {
  Between = 'BETWEEN',
  ContainsAny = 'CONTAINS_ANY',
  Equals = 'EQUALS',
  GreaterOrEqual = 'GREATER_OR_EQUAL',
  GreaterThan = 'GREATER_THAN',
  In = 'IN',
  InRange = 'IN_RANGE',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  LessOrEqual = 'LESS_OR_EQUAL',
  LessThan = 'LESS_THAN',
  Like = 'LIKE',
  LikeIgnoreCase = 'LIKE_IGNORE_CASE',
  NotEquals = 'NOT_EQUALS'
}

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PaginationInput = {
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};

export type ParameterDto = {
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type PermissionDto = {
  __typename?: 'PermissionDto';
  groupName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PermissionsDto = {
  __typename?: 'PermissionsDto';
  pagination: Pagination;
  rows: Array<PermissionDto>;
};

export enum PermissionsFieldSelector {
  /** Selector to filter on the group name of the permission */
  GroupName = 'GroupName',
  /** Selector to filter on the key of the permission */
  Key = 'Key',
  /** Selector to filter on the name of the permission */
  Name = 'Name'
}

/** Filter for permissions */
export type PermissionsFilterInput = {
  operator: Operator;
  orNull?: InputMaybe<Scalars['Boolean']['input']>;
  selector: PermissionsFieldSelector;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum PermissionsSortSelector {
  GroupName = 'groupName',
  Id = 'id',
  Name = 'name'
}

export type PermissionsSortingInput = {
  direction: Direction;
  selector: PermissionsSortSelector;
};

export type QuarterAndYearParameterDto = BaseParameter & ParameterDto & {
  __typename?: 'QuarterAndYearParameterDto';
  maxYearValue: Scalars['String']['output'];
  minYearValue: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  possibleQuarters: Array<Scalars['String']['output']>;
  quarterPath: Scalars['String']['output'];
  type: Scalars['String']['output'];
  yearPath: Scalars['String']['output'];
};

export type QuarterAndYearParameterInput = {
  path: Scalars['String']['input'];
  quarterPath: Scalars['String']['input'];
  quarters: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  yearPath: Scalars['String']['input'];
  years: Array<Scalars['String']['input']>;
};

export type QuarterParameterDto = BaseParameter & ParameterDto & {
  __typename?: 'QuarterParameterDto';
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  possibleValues: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Check the status of an async action with given ID */
  checkAsyncAction: AsyncActionDto;
  /** Check the existence of healthcare provider excerpt credentials for the given COC numbers */
  checkHealthcareProviderExcerptExistence: Array<HealthcareProviderExcerptExistenceDto>;
  /** Get the authenticated user (if any). This includes an ID that should be used for administering the user. */
  getAuthenticatedUser?: Maybe<UserDto>;
  /** Get the details for each of the given indicators */
  getCredentialDetailsForIndicators: Array<IndicatorDetailDto>;
  /** Get list of exchange profiles */
  getExchangeProfiles: Array<ExchangeProfileDto>;
  /** Get list of healthcare providers */
  getHealthcareProviders: Array<HealthcareProviderDetailsDto>;
  /** Get details for an issued credential */
  getIssuedCredentialById: IssuedCredentialDetailsDto;
  /** Get a page of issued healthcare provider excerpt credentials */
  getIssuedHealthcareProviderExcerptCredentials: IssuedHealthcareProviderExcerptCredentialPage;
  /** Get a paginated overview of subject dids */
  getPaginatedSubjectDids: SubjectDidsDto;
  /** Get a paginated list of permissions */
  getPermissions: PermissionsDto;
  /** Get a single role by ID */
  getRole?: Maybe<RoleDto>;
  /** Get a paginated list of roles */
  getRoles: RolesDto;
  /** Get a subject did by id */
  getSubjectDid: SubjectDidDto;
  /** Get list of subjects with their Verifiable Query credentials */
  getSubjectsWithVerifiableQueryCredentials: Array<SubjectWithVerifiableQueryCredentialsDto>;
  /** Get a single user by ID */
  getUser?: Maybe<UserDto>;
  /** Get a paginated list of users */
  getUsers: UsersDto;
  /** Returns true if subject has revoked credentials */
  hasSubjectRevokedCredentials: Scalars['Boolean']['output'];
  /** Very simple ping-pong call to test basic GraphQL functionality */
  ping: Scalars['String']['output'];
  /**
   *
   *         Validate the given list of credentials that are to be issued for the given subject DIDs, and return whether the input is valid.
   *         Invalidness can occur if a subject DID already has a credential for one of the indicators, or if an indicator requires a healthcare
   *         provider IRI whilst the subject DID does not have one configured.
   *
   */
  validateCredentialsCanBeIssuedForInput: VerifiableQueryCredentialValidationResultDto;
};


export type QueryCheckAsyncActionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCheckHealthcareProviderExcerptExistenceArgs = {
  cocNumbers: Array<Scalars['String']['input']>;
};


export type QueryGetCredentialDetailsForIndicatorsArgs = {
  indicators: Array<IndicatorInput>;
  input: GitRemoteInput;
};


export type QueryGetIssuedCredentialByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetIssuedHealthcareProviderExcerptCredentialsArgs = {
  filter?: InputMaybe<FilterIssuedHealthcareProviderExcerptCredentialInput>;
  pagination: PaginationInput;
};


export type QueryGetPaginatedSubjectDidsArgs = {
  filters: Array<SubjectDidsFilterInput>;
  paginationInput: PaginationInput;
  sorting: Array<SubjectDidsSortingInput>;
};


export type QueryGetPermissionsArgs = {
  filters: Array<PermissionsFilterInput>;
  paginationInput: PaginationInput;
  sorting: Array<PermissionsSortingInput>;
};


export type QueryGetRoleArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetRolesArgs = {
  filters: Array<RolesFilterInput>;
  paginationInput: PaginationInput;
  sorting: Array<RolesSortingInput>;
};


export type QueryGetSubjectDidArgs = {
  id: Scalars['Long']['input'];
};


export type QueryGetSubjectsWithVerifiableQueryCredentialsArgs = {
  filters?: InputMaybe<Array<VerifiableCredentialsFilterInput>>;
};


export type QueryGetUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetUsersArgs = {
  filters: Array<UsersFilterInput>;
  paginationInput: PaginationInput;
  sorting: Array<UsersSortingInput>;
};


export type QueryHasSubjectRevokedCredentialsArgs = {
  subjectId: Scalars['String']['input'];
};


export type QueryValidateCredentialsCanBeIssuedForInputArgs = {
  credentialInput: CredentialInput;
  input: GitRemoteInput;
  subjectIds: Array<Scalars['Long']['input']>;
};

export type ReferenceDateParameterDto = BaseParameter & DateParameterDto & ParameterDto & {
  __typename?: 'ReferenceDateParameterDto';
  maxInclusive?: Maybe<Scalars['String']['output']>;
  minInclusive?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReferenceDateParameterInput = {
  path: Scalars['String']['input'];
  possibleValues: Array<Scalars['Date']['input']>;
  type: Scalars['String']['input'];
};

export type RoleDto = {
  __typename?: 'RoleDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  modifiedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  permissions: Array<PermissionDto>;
};

export type RolesDto = {
  __typename?: 'RolesDto';
  pagination: Pagination;
  rows: Array<RoleDto>;
};

export enum RolesFieldSelector {
  /** Selector to filter on the keycloak id of the role */
  KeycloakId = 'KeycloakId',
  /** Selector to filter on the name of the role */
  Name = 'Name'
}

/** Filter for roles */
export type RolesFilterInput = {
  operator: Operator;
  orNull?: InputMaybe<Scalars['Boolean']['input']>;
  selector: RolesFieldSelector;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RolesSortSelector {
  Id = 'id',
  Name = 'name'
}

export type RolesSortingInput = {
  direction: Direction;
  selector: RolesSortSelector;
};

export type SimpleUserDto = {
  __typename?: 'SimpleUserDto';
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  lastName: Scalars['String']['output'];
};

export type StartDateParameterDto = BaseParameter & DateParameterDto & ParameterDto & {
  __typename?: 'StartDateParameterDto';
  maxInclusive?: Maybe<Scalars['String']['output']>;
  minInclusive?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StartDateParameterInput = {
  path: Scalars['String']['input'];
  possibleValues: Array<Scalars['Date']['input']>;
  type: Scalars['String']['input'];
};

export enum Status {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NoLongerAvailable = 'NO_LONGER_AVAILABLE'
}

export type SubjectDidDto = {
  __typename?: 'SubjectDidDto';
  healthcareOfficeIri?: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
  zinlDid: Scalars['String']['output'];
};

export type SubjectDidsDto = {
  __typename?: 'SubjectDidsDto';
  pagination: Pagination;
  rows: Array<SubjectDidDto>;
};

export enum SubjectDidsFieldSelector {
  /** Selector to filter on the healthcare office IRI of the subject DID */
  HealthcareOfficeIri = 'HealthcareOfficeIri',
  /** Selector to filter on the id of the subject DID */
  Id = 'Id',
  /** Selector to filter on the Keycloak id of the subject DID */
  KeycloakId = 'KeycloakId',
  /** Selector to filter on the name of the subject DID */
  Name = 'Name',
  /** Selector to filter on the revoked at timestamp of the subject DID */
  RevokedAt = 'RevokedAt',
  /** Selector to filter on who revoked the subject DID */
  RevokedBy = 'RevokedBy',
  /** Selector to filter on the ZINL DID of the subject DID */
  ZinlDid = 'ZinlDid'
}

/** Filter for subject DIDs */
export type SubjectDidsFilterInput = {
  operator: Operator;
  orNull?: InputMaybe<Scalars['Boolean']['input']>;
  selector: SubjectDidsFieldSelector;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum SubjectDidsSortSelector {
  HealthcareOfficeIri = 'healthcareOfficeIri',
  Id = 'id',
  KeycloakId = 'keycloakId',
  Name = 'name',
  RevokedAt = 'revokedAt',
  RevokedBy = 'revokedBy',
  ZinlDid = 'zinlDid'
}

export type SubjectDidsSortingInput = {
  direction: Direction;
  selector: SubjectDidsSortSelector;
};

export type SubjectWithVerifiableQueryCredentialsDto = {
  __typename?: 'SubjectWithVerifiableQueryCredentialsDto';
  exchangeProfiles: Array<ExchangeProfileWithCredentials>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

export type TagOrBranch = {
  __typename?: 'TagOrBranch';
  tagOrBranch: Scalars['String']['output'];
};

export enum Type {
  IssueCredentialsForIndicators = 'ISSUE_CREDENTIALS_FOR_INDICATORS'
}

export type UpdateRoleInput = {
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  permissions: Array<Scalars['UUID']['input']>;
};

export type UpdateSubjectDidInput = {
  healthcareOfficeIri?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Long']['input'];
};

export type UpdateUserInput = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
};

export type UserDto = {
  __typename?: 'UserDto';
  auditInfo: AuditInfoDto;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  role?: Maybe<RoleDto>;
};

export type UsersDto = {
  __typename?: 'UsersDto';
  pagination: Pagination;
  rows: Array<UserDto>;
};

export enum UsersFieldSelector {
  /** Selector to filter on the created at timestamp of the user */
  CreatedAt = 'CreatedAt',
  /** Selector to filter on the deleted state of the user */
  Deleted = 'Deleted',
  /** Selector to filter on the email address of the user */
  EmailAddress = 'EmailAddress',
  /** Selector to filter on the enabled status of the user */
  Enabled = 'Enabled',
  /** Selector to filter on the first name of the user */
  FirstName = 'FirstName',
  /** Selector to filter on the id of the user */
  Id = 'Id',
  /** Selector to filter on the last name of the user */
  LastName = 'LastName',
  /** Selector to filter on the modified at timestamp of the user */
  UpdatedAt = 'UpdatedAt'
}

/** Filter for users */
export type UsersFilterInput = {
  operator: Operator;
  orNull?: InputMaybe<Scalars['Boolean']['input']>;
  selector: UsersFieldSelector;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum UsersSortSelector {
  CreatedAt = 'createdAt',
  EmailAddress = 'emailAddress',
  Enabled = 'enabled',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  ModifiedAt = 'modifiedAt'
}

export type UsersSortingInput = {
  direction: Direction;
  selector: UsersSortSelector;
};

export enum VerifiableCredentialsFieldSelector {
  /** Selector to filter on the revoked at field */
  RevokedAt = 'RevokedAt',
  /** Filter on statuses */
  Status = 'Status',
  /** Selector to search on the subject id of the verifiable credentials */
  SubjectId = 'SubjectId'
}

/** Filter for modules */
export type VerifiableCredentialsFilterInput = {
  operator: Operator;
  orNull?: InputMaybe<Scalars['Boolean']['input']>;
  selector: VerifiableCredentialsFieldSelector;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiableQueryCredentialDto = {
  __typename?: 'VerifiableQueryCredentialDto';
  id: Scalars['UUID']['output'];
  issuedAt?: Maybe<Scalars['LocalDateTime']['output']>;
  name: Scalars['String']['output'];
  status: IssuedCredentialStatusEnum;
};

export type VerifiableQueryCredentialIssuanceResultDto = {
  __typename?: 'VerifiableQueryCredentialIssuanceResultDto';
  indicator: IndicatorDto;
  subjectDid: Scalars['String']['output'];
  successful: Scalars['Boolean']['output'];
  unsuccessful?: Maybe<CredentialMutationFailureDto>;
};

/**
 *
 *     Result of validating the inputs for one or more Verifiable Query Credentials for a list of subjects. When the list of failures
 *     is empty, the input is valid and can be used to issue the credentials. The list of failures is ordered by subject ID.
 *
 */
export type VerifiableQueryCredentialValidationResultDto = {
  __typename?: 'VerifiableQueryCredentialValidationResultDto';
  failures: Array<Failure>;
};

export type YearParameterDto = BaseParameter & ParameterDto & {
  __typename?: 'YearParameterDto';
  maxInclusive: Scalars['String']['output'];
  minInclusive: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type YearParameterInput = {
  path: Scalars['String']['input'];
  possibleValues: Array<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CredentialRevocationResultFragment = { __typename?: 'CredentialRevocationResultDto', id: any, scheduled: boolean, successful: boolean, unsuccessful?: { __typename?: 'CredentialMutationFailureDto', reasonPhrase: string, location: FailureLocation } | null };

export type PermissionFragmentFragment = { __typename?: 'RoleDto', permissions: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> };

export type SimpleUserFragmentFragment = { __typename?: 'UserDto', id: any, email: string, firstName: string, lastName: string, isEnabled: boolean, role?: { __typename?: 'RoleDto', id: any, name: string } | null, auditInfo: { __typename?: 'AuditInfoDto', createdAt: any, createdBy: { __typename?: 'SimpleUserDto', id: any, firstName: string, lastName: string } } };

export type GetAuthenticatedUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatedUserQuery = { __typename?: 'Query', getAuthenticatedUser?: { __typename?: 'UserDto', id: any, email: string, firstName: string, lastName: string, isEnabled: boolean, role?: { __typename?: 'RoleDto', createdAt: any, id: any, modifiedAt?: any | null, name: string, permissions: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> } | null, auditInfo: { __typename?: 'AuditInfoDto', createdAt: any, createdBy: { __typename?: 'SimpleUserDto', id: any, firstName: string, lastName: string } } } | null };

export type GetHealthcareProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHealthcareProvidersQuery = { __typename?: 'Query', getHealthcareProviders: Array<{ __typename?: 'HealthcareProviderDetailsDto', id: any, name: string, cocNumber: string, did: string, hasIssuedCredential: boolean }> };

export type HasSubjectRevokedCredentialsQueryVariables = Exact<{
  subjectId: Scalars['String']['input'];
}>;


export type HasSubjectRevokedCredentialsQuery = { __typename?: 'Query', hasSubjectRevokedCredentials: boolean };

export type ValidateCredentialInputQueryVariables = Exact<{
  input: GitRemoteInput;
  indicators: Array<IndicatorInput> | IndicatorInput;
  subjectIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type ValidateCredentialInputQuery = { __typename?: 'Query', validateCredentialsCanBeIssuedForInput: { __typename?: 'VerifiableQueryCredentialValidationResultDto', failures: Array<{ __typename?: 'Failure', subjectId: any, reason: FailureReason, indicator: { __typename?: 'IndicatorDto', name: string, path: string } }> } };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetUserByIdQuery = { __typename?: 'Query', getUser?: { __typename?: 'UserDto', id: any, email: string, firstName: string, lastName: string, isEnabled: boolean, role?: { __typename?: 'RoleDto', id: any, name: string } | null, auditInfo: { __typename?: 'AuditInfoDto', createdAt: any, createdBy: { __typename?: 'SimpleUserDto', id: any, firstName: string, lastName: string } } } | null };

export type GetUsersQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  filters: Array<UsersFilterInput> | UsersFilterInput;
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: { __typename?: 'UsersDto', rows: Array<{ __typename?: 'UserDto', id: any, email: string, firstName: string, lastName: string, isEnabled: boolean, role?: { __typename?: 'RoleDto', id: any, name: string } | null, auditInfo: { __typename?: 'AuditInfoDto', createdAt: any, createdBy: { __typename?: 'SimpleUserDto', id: any, firstName: string, lastName: string } } }>, pagination: { __typename?: 'Pagination', page: number, pageSize: number, totalCount: number } } };

export type GetExchangeProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExchangeProfilesQuery = { __typename?: 'Query', getExchangeProfiles: Array<{ __typename?: 'ExchangeProfileDto', id: string, name: string, url: string, tagsAndBranches: Array<{ __typename?: 'TagOrBranch', tagOrBranch: string }> }> };

export type GetCredentialDetailsForIndicatorsQueryVariables = Exact<{
  repositoryUrl: Scalars['String']['input'];
  branchOrTag?: InputMaybe<Scalars['String']['input']>;
  indicators: Array<IndicatorInput> | IndicatorInput;
}>;


export type GetCredentialDetailsForIndicatorsQuery = { __typename?: 'Query', detailsForIndicators: Array<{ __typename?: 'IndicatorDetailDto', queryName: string, queryDescription: string, sparql: string, paramsSHACL?: string | null, profileUrl: string, indicator: { __typename?: 'IndicatorDto', name: string, path: string }, ontologies: Array<{ __typename?: 'OntologyDto', title: string, tagOrBranch: string }>, parameters: Array<{ __typename?: 'DateRangeParameterDto', type: string, endMaxDate?: string | null, endMinDate?: string | null, startMaxDate?: string | null, startMinDate?: string | null, maxDatePath: string, minDatePath: string, name: string, path: string } | { __typename?: 'EndDateParameterDto', type: string, name: string, path: string } | { __typename?: 'QuarterAndYearParameterDto', type: string, maxYearValue: string, minYearValue: string, possibleQuarters: Array<string>, yearPath: string, quarterPath: string, name: string, path: string } | { __typename?: 'QuarterParameterDto', name: string, path: string } | { __typename?: 'ReferenceDateParameterDto', type: string, name: string, path: string } | { __typename?: 'StartDateParameterDto', type: string, name: string, path: string } | { __typename?: 'YearParameterDto', type: string, name: string, path: string, minInclusive: string, maxInclusive: string }> }> };

export type GetIssuedVerifiableQueryCredentialsQueryVariables = Exact<{
  filters?: InputMaybe<Array<VerifiableCredentialsFilterInput> | VerifiableCredentialsFilterInput>;
}>;


export type GetIssuedVerifiableQueryCredentialsQuery = { __typename?: 'Query', getSubjectsWithVerifiableQueryCredentials: Array<{ __typename?: 'SubjectWithVerifiableQueryCredentialsDto', id: any, name: string, exchangeProfiles: Array<{ __typename?: 'ExchangeProfileWithCredentials', name: string, version: string, credentials: Array<{ __typename?: 'VerifiableQueryCredentialDto', id: any, name: string, status: IssuedCredentialStatusEnum, issuedAt?: any | null }> }> }> };

export type GetIssuedCredentialByIdQueryVariables = Exact<{
  getIssuedCredentialByIdId: Scalars['UUID']['input'];
}>;


export type GetIssuedCredentialByIdQuery = { __typename?: 'Query', getIssuedCredentialById: { __typename?: 'IssuedCredentialDetailsDto', exchangeProfile?: string | null, id?: any | null, issuedAt?: any | null, nutsId?: string | null, shacl?: string | null, sparql?: string | null, tagOrBranch?: string | null, user?: { __typename?: 'UserDto', firstName: string, lastName: string, email: string } | null } };

export type GetIssuedCredentialsQueryVariables = Exact<{
  pagination: PaginationInput;
  search: Scalars['String']['input'];
}>;


export type GetIssuedCredentialsQuery = { __typename?: 'Query', getIssuedHealthcareProviderExcerptCredentials: { __typename?: 'IssuedHealthcareProviderExcerptCredentialPage', page: number, rowCount: number, rows: Array<{ __typename?: 'IssuedHealthcareProviderExcerptCredentialDto', id: any, healthcareProvider: { __typename?: 'HealthcareProviderDto', id: any, name: string, cocNumber: string, did: string } }> } };

export type GetPermissionsQueryVariables = Exact<{
  paginationInput: PaginationInput;
  filters: Array<PermissionsFilterInput> | PermissionsFilterInput;
  sorting: Array<PermissionsSortingInput> | PermissionsSortingInput;
}>;


export type GetPermissionsQuery = { __typename?: 'Query', getPermissions: { __typename?: 'PermissionsDto', pagination: { __typename?: 'Pagination', page: number, pageSize: number, totalCount: number }, rows: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> } };

export type GetRoleQueryVariables = Exact<{
  getRoleId: Scalars['UUID']['input'];
}>;


export type GetRoleQuery = { __typename?: 'Query', getRole?: { __typename?: 'RoleDto', createdAt: any, id: any, modifiedAt?: any | null, name: string, permissions: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> } | null };

export type GetRolesQueryVariables = Exact<{
  paginationInput: PaginationInput;
  filters: Array<RolesFilterInput> | RolesFilterInput;
  sorting: Array<RolesSortingInput> | RolesSortingInput;
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: { __typename?: 'RolesDto', pagination: { __typename?: 'Pagination', page: number, pageSize: number, totalCount: number }, rows: Array<{ __typename?: 'RoleDto', createdAt: any, id: any, modifiedAt?: any | null, name: string, permissions: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> }> } };

export type GetPaginatedSubjectDidsQueryVariables = Exact<{
  paginationInput: PaginationInput;
  filters: Array<SubjectDidsFilterInput> | SubjectDidsFilterInput;
  sorting: Array<SubjectDidsSortingInput> | SubjectDidsSortingInput;
}>;


export type GetPaginatedSubjectDidsQuery = { __typename?: 'Query', getPaginatedSubjectDids: { __typename?: 'SubjectDidsDto', pagination: { __typename?: 'Pagination', page: number, pageSize: number, totalCount: number }, rows: Array<{ __typename?: 'SubjectDidDto', healthcareOfficeIri?: string | null, id: any, name: string, zinlDid: string }> } };

export type GetSubjectDidQueryVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type GetSubjectDidQuery = { __typename?: 'Query', getSubjectDid: { __typename?: 'SubjectDidDto', id: any, name: string, zinlDid: string, healthcareOfficeIri?: string | null } };

export type IssueCredentialsForHealthcareProvidersMutationVariables = Exact<{
  ids: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type IssueCredentialsForHealthcareProvidersMutation = { __typename?: 'Mutation', issueCredentialsForHealthcareProviders: Array<{ __typename?: 'HealthcareProviderExcerptCredentialIssuanceResultDto', id: any, successful: boolean, unsuccessful?: { __typename?: 'CredentialMutationFailureDto', reasonPhrase: string, location: FailureLocation } | null }> };

export type RevokeHealthcareProviderExcerptCredentialMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type RevokeHealthcareProviderExcerptCredentialMutation = { __typename?: 'Mutation', revokeHealthcareProviderExcerptCredential: Array<{ __typename?: 'CredentialRevocationResultDto', id: any, scheduled: boolean, successful: boolean, unsuccessful?: { __typename?: 'CredentialMutationFailureDto', reasonPhrase: string, location: FailureLocation } | null }> };

export type CheckActionResultQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CheckActionResultQuery = { __typename?: 'Query', checkAsyncAction: { __typename?: 'AsyncActionDto', id: any, status: Status, data?: string | null } };

export type StartIssueCredentialsForIndicatorsMutationVariables = Exact<{
  gitRemoteInput: GitRemoteInput;
  credentialInput: CredentialInput;
  subjectIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type StartIssueCredentialsForIndicatorsMutation = { __typename?: 'Mutation', startIssueCredentialsForIndicatorsAction: { __typename?: 'AsyncActionDto', id: any, type: Type, status: Status } };

export type IssueCredentialsForIndicatorsMutationVariables = Exact<{
  input: GitRemoteInput;
  credentialInput: CredentialInput;
  subjectIds: Array<Scalars['Long']['input']> | Scalars['Long']['input'];
}>;


export type IssueCredentialsForIndicatorsMutation = { __typename?: 'Mutation', issueCredentialsForIndicators: Array<{ __typename?: 'VerifiableQueryCredentialIssuanceResultDto', subjectDid: string, successful: boolean, indicator: { __typename?: 'IndicatorDto', name: string, path: string }, unsuccessful?: { __typename?: 'CredentialMutationFailureDto', reasonPhrase: string, location: FailureLocation } | null }> };

export type RevokeCredentialsMutationVariables = Exact<{
  ids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  revokeAt?: InputMaybe<Scalars['LocalDateTime']['input']>;
}>;


export type RevokeCredentialsMutation = { __typename?: 'Mutation', revokeVerifiableQueryCredentials: Array<{ __typename?: 'CredentialRevocationResultDto', id: any, scheduled: boolean, successful: boolean, unsuccessful?: { __typename?: 'CredentialMutationFailureDto', reasonPhrase: string, location: FailureLocation } | null }> };

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole: { __typename?: 'RoleDto', id: any, name: string, permissions: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> } };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole: { __typename?: 'RoleDto', createdAt: any, id: any, modifiedAt?: any | null, name: string, permissions: Array<{ __typename?: 'PermissionDto', groupName: string, id: any, key: string, name: string }> } };

export type RevokeSubjectDidMutationVariables = Exact<{
  id: Scalars['Long']['input'];
}>;


export type RevokeSubjectDidMutation = { __typename?: 'Mutation', revokeSubjectDid: { __typename?: 'ActionResult', success: boolean } };

export type UpdateSubjectDidMutationVariables = Exact<{
  input: UpdateSubjectDidInput;
}>;


export type UpdateSubjectDidMutation = { __typename?: 'Mutation', updateSubjectDid: { __typename?: 'SubjectDidDto', name: string, zinlDid: string, healthcareOfficeIri?: string | null } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'UserDto', firstName: string, lastName: string, id: any, email: string } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeactivateUserMutation = { __typename?: 'Mutation', deactivateUser: { __typename?: 'UserDto', id: any, email: string, firstName: string, lastName: string, isEnabled: boolean, role?: { __typename?: 'RoleDto', id: any, name: string } | null, auditInfo: { __typename?: 'AuditInfoDto', createdAt: any, createdBy: { __typename?: 'SimpleUserDto', id: any, firstName: string, lastName: string } } } };

export type ReactivateUserMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReactivateUserMutation = { __typename?: 'Mutation', reactivateUser: { __typename?: 'UserDto', id: any, email: string, firstName: string, lastName: string, isEnabled: boolean, role?: { __typename?: 'RoleDto', id: any, name: string } | null, auditInfo: { __typename?: 'AuditInfoDto', createdAt: any, createdBy: { __typename?: 'SimpleUserDto', id: any, firstName: string, lastName: string } } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserDto', firstName: string, lastName: string, id: any, email: string, role?: { __typename?: 'RoleDto', id: any, name: string } | null } };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename?: 'Query', ping: string };

export const CredentialRevocationResultFragmentDoc = gql`
    fragment CredentialRevocationResult on CredentialRevocationResultDto {
  id
  scheduled
  successful
  unsuccessful {
    reasonPhrase
    location
  }
}
    `;
export const PermissionFragmentFragmentDoc = gql`
    fragment PermissionFragment on RoleDto {
  permissions {
    groupName
    id
    key
    name
  }
}
    `;
export const SimpleUserFragmentFragmentDoc = gql`
    fragment SimpleUserFragment on UserDto {
  id
  email
  firstName
  lastName
  isEnabled
  role {
    id
    name
  }
  auditInfo {
    createdAt
    createdBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export const GetAuthenticatedUserDocument = gql`
    query GetAuthenticatedUser {
  getAuthenticatedUser {
    ...SimpleUserFragment
    role {
      createdAt
      id
      modifiedAt
      name
      ...PermissionFragment
    }
  }
}
    ${SimpleUserFragmentFragmentDoc}
${PermissionFragmentFragmentDoc}`;

/**
 * __useGetAuthenticatedUserQuery__
 *
 * To run a query within a React component, call `useGetAuthenticatedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthenticatedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthenticatedUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAuthenticatedUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(GetAuthenticatedUserDocument, options);
      }
export function useGetAuthenticatedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(GetAuthenticatedUserDocument, options);
        }
// @ts-ignore
export function useGetAuthenticatedUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>;
export function useGetAuthenticatedUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthenticatedUserQuery | undefined, GetAuthenticatedUserQueryVariables>;
export function useGetAuthenticatedUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>(GetAuthenticatedUserDocument, options);
        }
export type GetAuthenticatedUserQueryHookResult = ReturnType<typeof useGetAuthenticatedUserQuery>;
export type GetAuthenticatedUserLazyQueryHookResult = ReturnType<typeof useGetAuthenticatedUserLazyQuery>;
export type GetAuthenticatedUserSuspenseQueryHookResult = ReturnType<typeof useGetAuthenticatedUserSuspenseQuery>;
export type GetAuthenticatedUserQueryResult = Apollo.QueryResult<GetAuthenticatedUserQuery, GetAuthenticatedUserQueryVariables>;
export const GetHealthcareProvidersDocument = gql`
    query GetHealthcareProviders {
  getHealthcareProviders {
    id
    name
    cocNumber
    did
    hasIssuedCredential
  }
}
    `;

/**
 * __useGetHealthcareProvidersQuery__
 *
 * To run a query within a React component, call `useGetHealthcareProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHealthcareProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHealthcareProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHealthcareProvidersQuery(baseOptions?: Apollo.QueryHookOptions<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>(GetHealthcareProvidersDocument, options);
      }
export function useGetHealthcareProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>(GetHealthcareProvidersDocument, options);
        }
// @ts-ignore
export function useGetHealthcareProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>;
export function useGetHealthcareProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<GetHealthcareProvidersQuery | undefined, GetHealthcareProvidersQueryVariables>;
export function useGetHealthcareProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>(GetHealthcareProvidersDocument, options);
        }
export type GetHealthcareProvidersQueryHookResult = ReturnType<typeof useGetHealthcareProvidersQuery>;
export type GetHealthcareProvidersLazyQueryHookResult = ReturnType<typeof useGetHealthcareProvidersLazyQuery>;
export type GetHealthcareProvidersSuspenseQueryHookResult = ReturnType<typeof useGetHealthcareProvidersSuspenseQuery>;
export type GetHealthcareProvidersQueryResult = Apollo.QueryResult<GetHealthcareProvidersQuery, GetHealthcareProvidersQueryVariables>;
export const HasSubjectRevokedCredentialsDocument = gql`
    query HasSubjectRevokedCredentials($subjectId: String!) {
  hasSubjectRevokedCredentials(subjectId: $subjectId)
}
    `;

/**
 * __useHasSubjectRevokedCredentialsQuery__
 *
 * To run a query within a React component, call `useHasSubjectRevokedCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSubjectRevokedCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSubjectRevokedCredentialsQuery({
 *   variables: {
 *      subjectId: // value for 'subjectId'
 *   },
 * });
 */
export function useHasSubjectRevokedCredentialsQuery(baseOptions: Apollo.QueryHookOptions<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables> & ({ variables: HasSubjectRevokedCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>(HasSubjectRevokedCredentialsDocument, options);
      }
export function useHasSubjectRevokedCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>(HasSubjectRevokedCredentialsDocument, options);
        }
// @ts-ignore
export function useHasSubjectRevokedCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>;
export function useHasSubjectRevokedCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<HasSubjectRevokedCredentialsQuery | undefined, HasSubjectRevokedCredentialsQueryVariables>;
export function useHasSubjectRevokedCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>(HasSubjectRevokedCredentialsDocument, options);
        }
export type HasSubjectRevokedCredentialsQueryHookResult = ReturnType<typeof useHasSubjectRevokedCredentialsQuery>;
export type HasSubjectRevokedCredentialsLazyQueryHookResult = ReturnType<typeof useHasSubjectRevokedCredentialsLazyQuery>;
export type HasSubjectRevokedCredentialsSuspenseQueryHookResult = ReturnType<typeof useHasSubjectRevokedCredentialsSuspenseQuery>;
export type HasSubjectRevokedCredentialsQueryResult = Apollo.QueryResult<HasSubjectRevokedCredentialsQuery, HasSubjectRevokedCredentialsQueryVariables>;
export const ValidateCredentialInputDocument = gql`
    query ValidateCredentialInput($input: GitRemoteInput!, $indicators: [IndicatorInput!]!, $subjectIds: [Long!]!) {
  validateCredentialsCanBeIssuedForInput(
    input: $input
    credentialInput: {indicators: $indicators, issueAt: null}
    subjectIds: $subjectIds
  ) {
    failures {
      indicator {
        name
        path
      }
      subjectId
      reason
    }
  }
}
    `;

/**
 * __useValidateCredentialInputQuery__
 *
 * To run a query within a React component, call `useValidateCredentialInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateCredentialInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateCredentialInputQuery({
 *   variables: {
 *      input: // value for 'input'
 *      indicators: // value for 'indicators'
 *      subjectIds: // value for 'subjectIds'
 *   },
 * });
 */
export function useValidateCredentialInputQuery(baseOptions: Apollo.QueryHookOptions<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables> & ({ variables: ValidateCredentialInputQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>(ValidateCredentialInputDocument, options);
      }
export function useValidateCredentialInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>(ValidateCredentialInputDocument, options);
        }
// @ts-ignore
export function useValidateCredentialInputSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>;
export function useValidateCredentialInputSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>): Apollo.UseSuspenseQueryResult<ValidateCredentialInputQuery | undefined, ValidateCredentialInputQueryVariables>;
export function useValidateCredentialInputSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>(ValidateCredentialInputDocument, options);
        }
export type ValidateCredentialInputQueryHookResult = ReturnType<typeof useValidateCredentialInputQuery>;
export type ValidateCredentialInputLazyQueryHookResult = ReturnType<typeof useValidateCredentialInputLazyQuery>;
export type ValidateCredentialInputSuspenseQueryHookResult = ReturnType<typeof useValidateCredentialInputSuspenseQuery>;
export type ValidateCredentialInputQueryResult = Apollo.QueryResult<ValidateCredentialInputQuery, ValidateCredentialInputQueryVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: UUID!) {
  getUser(id: $id) {
    ...SimpleUserFragment
  }
}
    ${SimpleUserFragmentFragmentDoc}`;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables> & ({ variables: GetUserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
// @ts-ignore
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserByIdQuery | undefined, GetUserByIdQueryVariables>;
export function useGetUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserByIdSuspenseQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($page: Int!, $pageSize: Int!, $filters: [UsersFilterInput!]!) {
  getUsers(
    paginationInput: {page: $page, pageSize: $pageSize}
    filters: $filters
    sorting: []
  ) {
    rows {
      ...SimpleUserFragment
    }
    pagination {
      page
      pageSize
      totalCount
    }
  }
}
    ${SimpleUserFragmentFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables> & ({ variables: GetUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetExchangeProfilesDocument = gql`
    query getExchangeProfiles {
  getExchangeProfiles {
    id
    name
    url
    tagsAndBranches {
      tagOrBranch
    }
  }
}
    `;

/**
 * __useGetExchangeProfilesQuery__
 *
 * To run a query within a React component, call `useGetExchangeProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExchangeProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExchangeProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExchangeProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>(GetExchangeProfilesDocument, options);
      }
export function useGetExchangeProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>(GetExchangeProfilesDocument, options);
        }
// @ts-ignore
export function useGetExchangeProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>;
export function useGetExchangeProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetExchangeProfilesQuery | undefined, GetExchangeProfilesQueryVariables>;
export function useGetExchangeProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>(GetExchangeProfilesDocument, options);
        }
export type GetExchangeProfilesQueryHookResult = ReturnType<typeof useGetExchangeProfilesQuery>;
export type GetExchangeProfilesLazyQueryHookResult = ReturnType<typeof useGetExchangeProfilesLazyQuery>;
export type GetExchangeProfilesSuspenseQueryHookResult = ReturnType<typeof useGetExchangeProfilesSuspenseQuery>;
export type GetExchangeProfilesQueryResult = Apollo.QueryResult<GetExchangeProfilesQuery, GetExchangeProfilesQueryVariables>;
export const GetCredentialDetailsForIndicatorsDocument = gql`
    query GetCredentialDetailsForIndicators($repositoryUrl: String!, $branchOrTag: String, $indicators: [IndicatorInput!]!) {
  detailsForIndicators: getCredentialDetailsForIndicators(
    input: {repositoryUrl: $repositoryUrl, branchOrTag: $branchOrTag}
    indicators: $indicators
  ) {
    indicator {
      name
      path
    }
    queryName
    queryDescription
    sparql
    paramsSHACL
    profileUrl
    ontologies {
      title
      tagOrBranch
    }
    parameters {
      name
      path
      ... on DateRangeParameterDto {
        type
      }
      ... on ReferenceDateParameterDto {
        type
      }
      ... on StartDateParameterDto {
        type
      }
      ... on EndDateParameterDto {
        type
      }
      ... on QuarterAndYearParameterDto {
        type
        maxYearValue
        minYearValue
        possibleQuarters
        yearPath
        quarterPath
      }
      ... on DateRangeParameterDto {
        type
        endMaxDate
        endMinDate
        startMaxDate
        startMinDate
        maxDatePath
        minDatePath
      }
      ... on YearParameterDto {
        type
        name
        path
        minInclusive
        maxInclusive
      }
    }
  }
}
    `;

/**
 * __useGetCredentialDetailsForIndicatorsQuery__
 *
 * To run a query within a React component, call `useGetCredentialDetailsForIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCredentialDetailsForIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCredentialDetailsForIndicatorsQuery({
 *   variables: {
 *      repositoryUrl: // value for 'repositoryUrl'
 *      branchOrTag: // value for 'branchOrTag'
 *      indicators: // value for 'indicators'
 *   },
 * });
 */
export function useGetCredentialDetailsForIndicatorsQuery(baseOptions: Apollo.QueryHookOptions<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables> & ({ variables: GetCredentialDetailsForIndicatorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>(GetCredentialDetailsForIndicatorsDocument, options);
      }
export function useGetCredentialDetailsForIndicatorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>(GetCredentialDetailsForIndicatorsDocument, options);
        }
// @ts-ignore
export function useGetCredentialDetailsForIndicatorsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>;
export function useGetCredentialDetailsForIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCredentialDetailsForIndicatorsQuery | undefined, GetCredentialDetailsForIndicatorsQueryVariables>;
export function useGetCredentialDetailsForIndicatorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>(GetCredentialDetailsForIndicatorsDocument, options);
        }
export type GetCredentialDetailsForIndicatorsQueryHookResult = ReturnType<typeof useGetCredentialDetailsForIndicatorsQuery>;
export type GetCredentialDetailsForIndicatorsLazyQueryHookResult = ReturnType<typeof useGetCredentialDetailsForIndicatorsLazyQuery>;
export type GetCredentialDetailsForIndicatorsSuspenseQueryHookResult = ReturnType<typeof useGetCredentialDetailsForIndicatorsSuspenseQuery>;
export type GetCredentialDetailsForIndicatorsQueryResult = Apollo.QueryResult<GetCredentialDetailsForIndicatorsQuery, GetCredentialDetailsForIndicatorsQueryVariables>;
export const GetIssuedVerifiableQueryCredentialsDocument = gql`
    query GetIssuedVerifiableQueryCredentials($filters: [VerifiableCredentialsFilterInput!]) {
  getSubjectsWithVerifiableQueryCredentials(filters: $filters) {
    id
    name
    exchangeProfiles {
      name
      version
      credentials {
        id
        name
        status
        issuedAt
      }
    }
  }
}
    `;

/**
 * __useGetIssuedVerifiableQueryCredentialsQuery__
 *
 * To run a query within a React component, call `useGetIssuedVerifiableQueryCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedVerifiableQueryCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedVerifiableQueryCredentialsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetIssuedVerifiableQueryCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>(GetIssuedVerifiableQueryCredentialsDocument, options);
      }
export function useGetIssuedVerifiableQueryCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>(GetIssuedVerifiableQueryCredentialsDocument, options);
        }
// @ts-ignore
export function useGetIssuedVerifiableQueryCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>;
export function useGetIssuedVerifiableQueryCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIssuedVerifiableQueryCredentialsQuery | undefined, GetIssuedVerifiableQueryCredentialsQueryVariables>;
export function useGetIssuedVerifiableQueryCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>(GetIssuedVerifiableQueryCredentialsDocument, options);
        }
export type GetIssuedVerifiableQueryCredentialsQueryHookResult = ReturnType<typeof useGetIssuedVerifiableQueryCredentialsQuery>;
export type GetIssuedVerifiableQueryCredentialsLazyQueryHookResult = ReturnType<typeof useGetIssuedVerifiableQueryCredentialsLazyQuery>;
export type GetIssuedVerifiableQueryCredentialsSuspenseQueryHookResult = ReturnType<typeof useGetIssuedVerifiableQueryCredentialsSuspenseQuery>;
export type GetIssuedVerifiableQueryCredentialsQueryResult = Apollo.QueryResult<GetIssuedVerifiableQueryCredentialsQuery, GetIssuedVerifiableQueryCredentialsQueryVariables>;
export const GetIssuedCredentialByIdDocument = gql`
    query GetIssuedCredentialById($getIssuedCredentialByIdId: UUID!) {
  getIssuedCredentialById(id: $getIssuedCredentialByIdId) {
    exchangeProfile
    id
    issuedAt
    nutsId
    shacl
    sparql
    tagOrBranch
    user {
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetIssuedCredentialByIdQuery__
 *
 * To run a query within a React component, call `useGetIssuedCredentialByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedCredentialByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedCredentialByIdQuery({
 *   variables: {
 *      getIssuedCredentialByIdId: // value for 'getIssuedCredentialByIdId'
 *   },
 * });
 */
export function useGetIssuedCredentialByIdQuery(baseOptions: Apollo.QueryHookOptions<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables> & ({ variables: GetIssuedCredentialByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>(GetIssuedCredentialByIdDocument, options);
      }
export function useGetIssuedCredentialByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>(GetIssuedCredentialByIdDocument, options);
        }
// @ts-ignore
export function useGetIssuedCredentialByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>;
export function useGetIssuedCredentialByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetIssuedCredentialByIdQuery | undefined, GetIssuedCredentialByIdQueryVariables>;
export function useGetIssuedCredentialByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>(GetIssuedCredentialByIdDocument, options);
        }
export type GetIssuedCredentialByIdQueryHookResult = ReturnType<typeof useGetIssuedCredentialByIdQuery>;
export type GetIssuedCredentialByIdLazyQueryHookResult = ReturnType<typeof useGetIssuedCredentialByIdLazyQuery>;
export type GetIssuedCredentialByIdSuspenseQueryHookResult = ReturnType<typeof useGetIssuedCredentialByIdSuspenseQuery>;
export type GetIssuedCredentialByIdQueryResult = Apollo.QueryResult<GetIssuedCredentialByIdQuery, GetIssuedCredentialByIdQueryVariables>;
export const GetIssuedCredentialsDocument = gql`
    query GetIssuedCredentials($pagination: PaginationInput!, $search: String!) {
  getIssuedHealthcareProviderExcerptCredentials(
    pagination: $pagination
    filter: {search: $search}
  ) {
    page
    rowCount
    rows {
      id
      healthcareProvider {
        id
        name
        cocNumber
        did
      }
    }
  }
}
    `;

/**
 * __useGetIssuedCredentialsQuery__
 *
 * To run a query within a React component, call `useGetIssuedCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuedCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuedCredentialsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetIssuedCredentialsQuery(baseOptions: Apollo.QueryHookOptions<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables> & ({ variables: GetIssuedCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>(GetIssuedCredentialsDocument, options);
      }
export function useGetIssuedCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>(GetIssuedCredentialsDocument, options);
        }
// @ts-ignore
export function useGetIssuedCredentialsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>;
export function useGetIssuedCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIssuedCredentialsQuery | undefined, GetIssuedCredentialsQueryVariables>;
export function useGetIssuedCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>(GetIssuedCredentialsDocument, options);
        }
export type GetIssuedCredentialsQueryHookResult = ReturnType<typeof useGetIssuedCredentialsQuery>;
export type GetIssuedCredentialsLazyQueryHookResult = ReturnType<typeof useGetIssuedCredentialsLazyQuery>;
export type GetIssuedCredentialsSuspenseQueryHookResult = ReturnType<typeof useGetIssuedCredentialsSuspenseQuery>;
export type GetIssuedCredentialsQueryResult = Apollo.QueryResult<GetIssuedCredentialsQuery, GetIssuedCredentialsQueryVariables>;
export const GetPermissionsDocument = gql`
    query GetPermissions($paginationInput: PaginationInput!, $filters: [PermissionsFilterInput!]!, $sorting: [PermissionsSortingInput!]!) {
  getPermissions(
    paginationInput: $paginationInput
    filters: $filters
    sorting: $sorting
  ) {
    pagination {
      page
      pageSize
      totalCount
    }
    rows {
      groupName
      id
      key
      name
    }
  }
}
    `;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *      filters: // value for 'filters'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables> & ({ variables: GetPermissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
// @ts-ignore
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsQuery | undefined, GetPermissionsQueryVariables>;
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsSuspenseQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const GetRoleDocument = gql`
    query GetRole($getRoleId: UUID!) {
  getRole(id: $getRoleId) {
    createdAt
    id
    modifiedAt
    name
    ...PermissionFragment
  }
}
    ${PermissionFragmentFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      getRoleId: // value for 'getRoleId'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables> & ({ variables: GetRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
// @ts-ignore
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleQuery, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>): Apollo.UseSuspenseQueryResult<GetRoleQuery | undefined, GetRoleQueryVariables>;
export function useGetRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleSuspenseQueryHookResult = ReturnType<typeof useGetRoleSuspenseQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles($paginationInput: PaginationInput!, $filters: [RolesFilterInput!]!, $sorting: [RolesSortingInput!]!) {
  getRoles(
    paginationInput: $paginationInput
    filters: $filters
    sorting: $sorting
  ) {
    pagination {
      page
      pageSize
      totalCount
    }
    rows {
      createdAt
      id
      modifiedAt
      name
      ...PermissionFragment
    }
  }
}
    ${PermissionFragmentFragmentDoc}`;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *      filters: // value for 'filters'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables> & ({ variables: GetRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
// @ts-ignore
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesQuery | undefined, GetRolesQueryVariables>;
export function useGetRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesSuspenseQueryHookResult = ReturnType<typeof useGetRolesSuspenseQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const GetPaginatedSubjectDidsDocument = gql`
    query GetPaginatedSubjectDids($paginationInput: PaginationInput!, $filters: [SubjectDidsFilterInput!]!, $sorting: [SubjectDidsSortingInput!]!) {
  getPaginatedSubjectDids(
    paginationInput: $paginationInput
    filters: $filters
    sorting: $sorting
  ) {
    pagination {
      page
      pageSize
      totalCount
    }
    rows {
      healthcareOfficeIri
      id
      name
      zinlDid
    }
  }
}
    `;

/**
 * __useGetPaginatedSubjectDidsQuery__
 *
 * To run a query within a React component, call `useGetPaginatedSubjectDidsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedSubjectDidsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedSubjectDidsQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *      filters: // value for 'filters'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetPaginatedSubjectDidsQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables> & ({ variables: GetPaginatedSubjectDidsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>(GetPaginatedSubjectDidsDocument, options);
      }
export function useGetPaginatedSubjectDidsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>(GetPaginatedSubjectDidsDocument, options);
        }
// @ts-ignore
export function useGetPaginatedSubjectDidsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>;
export function useGetPaginatedSubjectDidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaginatedSubjectDidsQuery | undefined, GetPaginatedSubjectDidsQueryVariables>;
export function useGetPaginatedSubjectDidsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>(GetPaginatedSubjectDidsDocument, options);
        }
export type GetPaginatedSubjectDidsQueryHookResult = ReturnType<typeof useGetPaginatedSubjectDidsQuery>;
export type GetPaginatedSubjectDidsLazyQueryHookResult = ReturnType<typeof useGetPaginatedSubjectDidsLazyQuery>;
export type GetPaginatedSubjectDidsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedSubjectDidsSuspenseQuery>;
export type GetPaginatedSubjectDidsQueryResult = Apollo.QueryResult<GetPaginatedSubjectDidsQuery, GetPaginatedSubjectDidsQueryVariables>;
export const GetSubjectDidDocument = gql`
    query GetSubjectDid($id: Long!) {
  getSubjectDid(id: $id) {
    id
    name
    zinlDid
    healthcareOfficeIri
  }
}
    `;

/**
 * __useGetSubjectDidQuery__
 *
 * To run a query within a React component, call `useGetSubjectDidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubjectDidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubjectDidQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubjectDidQuery(baseOptions: Apollo.QueryHookOptions<GetSubjectDidQuery, GetSubjectDidQueryVariables> & ({ variables: GetSubjectDidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubjectDidQuery, GetSubjectDidQueryVariables>(GetSubjectDidDocument, options);
      }
export function useGetSubjectDidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubjectDidQuery, GetSubjectDidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubjectDidQuery, GetSubjectDidQueryVariables>(GetSubjectDidDocument, options);
        }
// @ts-ignore
export function useGetSubjectDidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubjectDidQuery, GetSubjectDidQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubjectDidQuery, GetSubjectDidQueryVariables>;
export function useGetSubjectDidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubjectDidQuery, GetSubjectDidQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubjectDidQuery | undefined, GetSubjectDidQueryVariables>;
export function useGetSubjectDidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubjectDidQuery, GetSubjectDidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubjectDidQuery, GetSubjectDidQueryVariables>(GetSubjectDidDocument, options);
        }
export type GetSubjectDidQueryHookResult = ReturnType<typeof useGetSubjectDidQuery>;
export type GetSubjectDidLazyQueryHookResult = ReturnType<typeof useGetSubjectDidLazyQuery>;
export type GetSubjectDidSuspenseQueryHookResult = ReturnType<typeof useGetSubjectDidSuspenseQuery>;
export type GetSubjectDidQueryResult = Apollo.QueryResult<GetSubjectDidQuery, GetSubjectDidQueryVariables>;
export const IssueCredentialsForHealthcareProvidersDocument = gql`
    mutation IssueCredentialsForHealthcareProviders($ids: [Long!]!) {
  issueCredentialsForHealthcareProviders(ids: $ids) {
    id
    successful
    unsuccessful {
      reasonPhrase
      location
    }
  }
}
    `;
export type IssueCredentialsForHealthcareProvidersMutationFn = Apollo.MutationFunction<IssueCredentialsForHealthcareProvidersMutation, IssueCredentialsForHealthcareProvidersMutationVariables>;

/**
 * __useIssueCredentialsForHealthcareProvidersMutation__
 *
 * To run a mutation, you first call `useIssueCredentialsForHealthcareProvidersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCredentialsForHealthcareProvidersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCredentialsForHealthcareProvidersMutation, { data, loading, error }] = useIssueCredentialsForHealthcareProvidersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIssueCredentialsForHealthcareProvidersMutation(baseOptions?: Apollo.MutationHookOptions<IssueCredentialsForHealthcareProvidersMutation, IssueCredentialsForHealthcareProvidersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueCredentialsForHealthcareProvidersMutation, IssueCredentialsForHealthcareProvidersMutationVariables>(IssueCredentialsForHealthcareProvidersDocument, options);
      }
export type IssueCredentialsForHealthcareProvidersMutationHookResult = ReturnType<typeof useIssueCredentialsForHealthcareProvidersMutation>;
export type IssueCredentialsForHealthcareProvidersMutationResult = Apollo.MutationResult<IssueCredentialsForHealthcareProvidersMutation>;
export type IssueCredentialsForHealthcareProvidersMutationOptions = Apollo.BaseMutationOptions<IssueCredentialsForHealthcareProvidersMutation, IssueCredentialsForHealthcareProvidersMutationVariables>;
export const RevokeHealthcareProviderExcerptCredentialDocument = gql`
    mutation RevokeHealthcareProviderExcerptCredential($ids: [UUID!]!) {
  revokeHealthcareProviderExcerptCredential(ids: $ids) {
    ...CredentialRevocationResult
  }
}
    ${CredentialRevocationResultFragmentDoc}`;
export type RevokeHealthcareProviderExcerptCredentialMutationFn = Apollo.MutationFunction<RevokeHealthcareProviderExcerptCredentialMutation, RevokeHealthcareProviderExcerptCredentialMutationVariables>;

/**
 * __useRevokeHealthcareProviderExcerptCredentialMutation__
 *
 * To run a mutation, you first call `useRevokeHealthcareProviderExcerptCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeHealthcareProviderExcerptCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeHealthcareProviderExcerptCredentialMutation, { data, loading, error }] = useRevokeHealthcareProviderExcerptCredentialMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRevokeHealthcareProviderExcerptCredentialMutation(baseOptions?: Apollo.MutationHookOptions<RevokeHealthcareProviderExcerptCredentialMutation, RevokeHealthcareProviderExcerptCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeHealthcareProviderExcerptCredentialMutation, RevokeHealthcareProviderExcerptCredentialMutationVariables>(RevokeHealthcareProviderExcerptCredentialDocument, options);
      }
export type RevokeHealthcareProviderExcerptCredentialMutationHookResult = ReturnType<typeof useRevokeHealthcareProviderExcerptCredentialMutation>;
export type RevokeHealthcareProviderExcerptCredentialMutationResult = Apollo.MutationResult<RevokeHealthcareProviderExcerptCredentialMutation>;
export type RevokeHealthcareProviderExcerptCredentialMutationOptions = Apollo.BaseMutationOptions<RevokeHealthcareProviderExcerptCredentialMutation, RevokeHealthcareProviderExcerptCredentialMutationVariables>;
export const CheckActionResultDocument = gql`
    query CheckActionResult($id: UUID!) {
  checkAsyncAction(id: $id) {
    id
    status
    data
  }
}
    `;

/**
 * __useCheckActionResultQuery__
 *
 * To run a query within a React component, call `useCheckActionResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckActionResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckActionResultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCheckActionResultQuery(baseOptions: Apollo.QueryHookOptions<CheckActionResultQuery, CheckActionResultQueryVariables> & ({ variables: CheckActionResultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckActionResultQuery, CheckActionResultQueryVariables>(CheckActionResultDocument, options);
      }
export function useCheckActionResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckActionResultQuery, CheckActionResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckActionResultQuery, CheckActionResultQueryVariables>(CheckActionResultDocument, options);
        }
// @ts-ignore
export function useCheckActionResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckActionResultQuery, CheckActionResultQueryVariables>): Apollo.UseSuspenseQueryResult<CheckActionResultQuery, CheckActionResultQueryVariables>;
export function useCheckActionResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckActionResultQuery, CheckActionResultQueryVariables>): Apollo.UseSuspenseQueryResult<CheckActionResultQuery | undefined, CheckActionResultQueryVariables>;
export function useCheckActionResultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckActionResultQuery, CheckActionResultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckActionResultQuery, CheckActionResultQueryVariables>(CheckActionResultDocument, options);
        }
export type CheckActionResultQueryHookResult = ReturnType<typeof useCheckActionResultQuery>;
export type CheckActionResultLazyQueryHookResult = ReturnType<typeof useCheckActionResultLazyQuery>;
export type CheckActionResultSuspenseQueryHookResult = ReturnType<typeof useCheckActionResultSuspenseQuery>;
export type CheckActionResultQueryResult = Apollo.QueryResult<CheckActionResultQuery, CheckActionResultQueryVariables>;
export const StartIssueCredentialsForIndicatorsDocument = gql`
    mutation StartIssueCredentialsForIndicators($gitRemoteInput: GitRemoteInput!, $credentialInput: CredentialInput!, $subjectIds: [Long!]!) {
  startIssueCredentialsForIndicatorsAction(
    input: {gitRemoteInput: $gitRemoteInput, credentialInput: $credentialInput, subjectIds: $subjectIds}
  ) {
    id
    type
    status
  }
}
    `;
export type StartIssueCredentialsForIndicatorsMutationFn = Apollo.MutationFunction<StartIssueCredentialsForIndicatorsMutation, StartIssueCredentialsForIndicatorsMutationVariables>;

/**
 * __useStartIssueCredentialsForIndicatorsMutation__
 *
 * To run a mutation, you first call `useStartIssueCredentialsForIndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartIssueCredentialsForIndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startIssueCredentialsForIndicatorsMutation, { data, loading, error }] = useStartIssueCredentialsForIndicatorsMutation({
 *   variables: {
 *      gitRemoteInput: // value for 'gitRemoteInput'
 *      credentialInput: // value for 'credentialInput'
 *      subjectIds: // value for 'subjectIds'
 *   },
 * });
 */
export function useStartIssueCredentialsForIndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<StartIssueCredentialsForIndicatorsMutation, StartIssueCredentialsForIndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartIssueCredentialsForIndicatorsMutation, StartIssueCredentialsForIndicatorsMutationVariables>(StartIssueCredentialsForIndicatorsDocument, options);
      }
export type StartIssueCredentialsForIndicatorsMutationHookResult = ReturnType<typeof useStartIssueCredentialsForIndicatorsMutation>;
export type StartIssueCredentialsForIndicatorsMutationResult = Apollo.MutationResult<StartIssueCredentialsForIndicatorsMutation>;
export type StartIssueCredentialsForIndicatorsMutationOptions = Apollo.BaseMutationOptions<StartIssueCredentialsForIndicatorsMutation, StartIssueCredentialsForIndicatorsMutationVariables>;
export const IssueCredentialsForIndicatorsDocument = gql`
    mutation IssueCredentialsForIndicators($input: GitRemoteInput!, $credentialInput: CredentialInput!, $subjectIds: [Long!]!) {
  issueCredentialsForIndicators(
    input: $input
    credentialInput: $credentialInput
    subjectIds: $subjectIds
  ) {
    subjectDid
    indicator {
      name
      path
    }
    successful
    unsuccessful {
      reasonPhrase
      location
    }
  }
}
    `;
export type IssueCredentialsForIndicatorsMutationFn = Apollo.MutationFunction<IssueCredentialsForIndicatorsMutation, IssueCredentialsForIndicatorsMutationVariables>;

/**
 * __useIssueCredentialsForIndicatorsMutation__
 *
 * To run a mutation, you first call `useIssueCredentialsForIndicatorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueCredentialsForIndicatorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueCredentialsForIndicatorsMutation, { data, loading, error }] = useIssueCredentialsForIndicatorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      credentialInput: // value for 'credentialInput'
 *      subjectIds: // value for 'subjectIds'
 *   },
 * });
 */
export function useIssueCredentialsForIndicatorsMutation(baseOptions?: Apollo.MutationHookOptions<IssueCredentialsForIndicatorsMutation, IssueCredentialsForIndicatorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueCredentialsForIndicatorsMutation, IssueCredentialsForIndicatorsMutationVariables>(IssueCredentialsForIndicatorsDocument, options);
      }
export type IssueCredentialsForIndicatorsMutationHookResult = ReturnType<typeof useIssueCredentialsForIndicatorsMutation>;
export type IssueCredentialsForIndicatorsMutationResult = Apollo.MutationResult<IssueCredentialsForIndicatorsMutation>;
export type IssueCredentialsForIndicatorsMutationOptions = Apollo.BaseMutationOptions<IssueCredentialsForIndicatorsMutation, IssueCredentialsForIndicatorsMutationVariables>;
export const RevokeCredentialsDocument = gql`
    mutation revokeCredentials($ids: [UUID!]!, $revokeAt: LocalDateTime) {
  revokeVerifiableQueryCredentials(ids: $ids, revokeAt: $revokeAt) {
    ...CredentialRevocationResult
  }
}
    ${CredentialRevocationResultFragmentDoc}`;
export type RevokeCredentialsMutationFn = Apollo.MutationFunction<RevokeCredentialsMutation, RevokeCredentialsMutationVariables>;

/**
 * __useRevokeCredentialsMutation__
 *
 * To run a mutation, you first call `useRevokeCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCredentialsMutation, { data, loading, error }] = useRevokeCredentialsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      revokeAt: // value for 'revokeAt'
 *   },
 * });
 */
export function useRevokeCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCredentialsMutation, RevokeCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCredentialsMutation, RevokeCredentialsMutationVariables>(RevokeCredentialsDocument, options);
      }
export type RevokeCredentialsMutationHookResult = ReturnType<typeof useRevokeCredentialsMutation>;
export type RevokeCredentialsMutationResult = Apollo.MutationResult<RevokeCredentialsMutation>;
export type RevokeCredentialsMutationOptions = Apollo.BaseMutationOptions<RevokeCredentialsMutation, RevokeCredentialsMutationVariables>;
export const CreateRoleDocument = gql`
    mutation CreateRole($input: CreateRoleInput!) {
  createRole(input: $input) {
    id
    name
    ...PermissionFragment
  }
}
    ${PermissionFragmentFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation UpdateRole($input: UpdateRoleInput!) {
  updateRole(input: $input) {
    createdAt
    id
    modifiedAt
    name
    ...PermissionFragment
  }
}
    ${PermissionFragmentFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const RevokeSubjectDidDocument = gql`
    mutation RevokeSubjectDid($id: Long!) {
  revokeSubjectDid(id: $id) {
    success
  }
}
    `;
export type RevokeSubjectDidMutationFn = Apollo.MutationFunction<RevokeSubjectDidMutation, RevokeSubjectDidMutationVariables>;

/**
 * __useRevokeSubjectDidMutation__
 *
 * To run a mutation, you first call `useRevokeSubjectDidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSubjectDidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSubjectDidMutation, { data, loading, error }] = useRevokeSubjectDidMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeSubjectDidMutation(baseOptions?: Apollo.MutationHookOptions<RevokeSubjectDidMutation, RevokeSubjectDidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeSubjectDidMutation, RevokeSubjectDidMutationVariables>(RevokeSubjectDidDocument, options);
      }
export type RevokeSubjectDidMutationHookResult = ReturnType<typeof useRevokeSubjectDidMutation>;
export type RevokeSubjectDidMutationResult = Apollo.MutationResult<RevokeSubjectDidMutation>;
export type RevokeSubjectDidMutationOptions = Apollo.BaseMutationOptions<RevokeSubjectDidMutation, RevokeSubjectDidMutationVariables>;
export const UpdateSubjectDidDocument = gql`
    mutation UpdateSubjectDid($input: UpdateSubjectDidInput!) {
  updateSubjectDid(input: $input) {
    name
    zinlDid
    healthcareOfficeIri
  }
}
    `;
export type UpdateSubjectDidMutationFn = Apollo.MutationFunction<UpdateSubjectDidMutation, UpdateSubjectDidMutationVariables>;

/**
 * __useUpdateSubjectDidMutation__
 *
 * To run a mutation, you first call `useUpdateSubjectDidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubjectDidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubjectDidMutation, { data, loading, error }] = useUpdateSubjectDidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubjectDidMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubjectDidMutation, UpdateSubjectDidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubjectDidMutation, UpdateSubjectDidMutationVariables>(UpdateSubjectDidDocument, options);
      }
export type UpdateSubjectDidMutationHookResult = ReturnType<typeof useUpdateSubjectDidMutation>;
export type UpdateSubjectDidMutationResult = Apollo.MutationResult<UpdateSubjectDidMutation>;
export type UpdateSubjectDidMutationOptions = Apollo.BaseMutationOptions<UpdateSubjectDidMutation, UpdateSubjectDidMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    firstName
    lastName
    id
    email
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($id: UUID!) {
  deactivateUser(id: $id) {
    ...SimpleUserFragment
  }
}
    ${SimpleUserFragmentFragmentDoc}`;
export type DeactivateUserMutationFn = Apollo.MutationFunction<DeactivateUserMutation, DeactivateUserMutationVariables>;

/**
 * __useDeactivateUserMutation__
 *
 * To run a mutation, you first call `useDeactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserMutation, { data, loading, error }] = useDeactivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserMutation, DeactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserMutation, DeactivateUserMutationVariables>(DeactivateUserDocument, options);
      }
export type DeactivateUserMutationHookResult = ReturnType<typeof useDeactivateUserMutation>;
export type DeactivateUserMutationResult = Apollo.MutationResult<DeactivateUserMutation>;
export type DeactivateUserMutationOptions = Apollo.BaseMutationOptions<DeactivateUserMutation, DeactivateUserMutationVariables>;
export const ReactivateUserDocument = gql`
    mutation ReactivateUser($id: UUID!) {
  reactivateUser(id: $id) {
    ...SimpleUserFragment
  }
}
    ${SimpleUserFragmentFragmentDoc}`;
export type ReactivateUserMutationFn = Apollo.MutationFunction<ReactivateUserMutation, ReactivateUserMutationVariables>;

/**
 * __useReactivateUserMutation__
 *
 * To run a mutation, you first call `useReactivateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateUserMutation, { data, loading, error }] = useReactivateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReactivateUserMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateUserMutation, ReactivateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateUserMutation, ReactivateUserMutationVariables>(ReactivateUserDocument, options);
      }
export type ReactivateUserMutationHookResult = ReturnType<typeof useReactivateUserMutation>;
export type ReactivateUserMutationResult = Apollo.MutationResult<ReactivateUserMutation>;
export type ReactivateUserMutationOptions = Apollo.BaseMutationOptions<ReactivateUserMutation, ReactivateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    firstName
    lastName
    id
    email
    role {
      id
      name
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const PingDocument = gql`
    query Ping {
  ping
}
    `;

/**
 * __usePingQuery__
 *
 * To run a query within a React component, call `usePingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingQuery(baseOptions?: Apollo.QueryHookOptions<PingQuery, PingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingQuery, PingQueryVariables>(PingDocument, options);
      }
export function usePingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingQuery, PingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingQuery, PingQueryVariables>(PingDocument, options);
        }
// @ts-ignore
export function usePingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PingQuery, PingQueryVariables>): Apollo.UseSuspenseQueryResult<PingQuery, PingQueryVariables>;
export function usePingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingQuery, PingQueryVariables>): Apollo.UseSuspenseQueryResult<PingQuery | undefined, PingQueryVariables>;
export function usePingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PingQuery, PingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PingQuery, PingQueryVariables>(PingDocument, options);
        }
export type PingQueryHookResult = ReturnType<typeof usePingQuery>;
export type PingLazyQueryHookResult = ReturnType<typeof usePingLazyQuery>;
export type PingSuspenseQueryHookResult = ReturnType<typeof usePingSuspenseQuery>;
export type PingQueryResult = Apollo.QueryResult<PingQuery, PingQueryVariables>;